/* istanbul ignore file */
import Loadable from 'react-loadable';

const CityVenueCard = Loadable({
  loader: () => import(/* webpackChunkName: "swi-CityVenueCard" */ '../react-city-venue-card'),
  loading: () => null,
});

export default CityVenueCard;
